const sectionDispatcher = require("./events/section/sectionDispatchers.js");
const store = require("./store.js");
const config = require("./config.js");

const tickTimeMS = config.AutoSaveTickTimeMins * 60 * 1000;

const autosaver = {
    TickerHandle: null,
    Start() {
        autosaver.TickerHandle = setTimeout(autosaver.OnTick, tickTimeMS);

        console.log(`Autosaver started; ticking at ${tickTimeMS}ms.`);
    },
    OnTick() {
        if (autosaver.ShouldSave()) {
            autosaver.Save();

            autosaver.TickerHandle = setTimeout(autosaver.OnTick, tickTimeMS);
            
            return;
        }

        console.log("dont save");

        autosaver.TickerHandle = setTimeout(autosaver.OnTick, tickTimeMS);
    },
    ShouldSave() {
        const state = store.getState();
        
        if (state.MainViewName !== config.MainViewNames.Survey) return false;

        if (state.IsSaving) return false;

        if (state.SaveError) return false;
        
        if ((state.CurrentSurvey.Pages || []).length === 0) return false;

        return true;
    },
    Save() {
        const state = store.getState();

        const page = state.CurrentSurvey.Pages.find((p) => {
            return p.GUID === state.CurrentSurvey.CurrentPageGUID;
        });

        if (!page) {
            throw "No page was found to save.";
        }

        const section = page.Sections.find((s) => {
            return s.GUID === state.CurrentSurvey.CurrentSectionGUID;
        });

        if (!section) {
            throw "No section was found to save.";
        }

        const path = [
            state.CurrentSurvey.Type,
            state.CurrentSurvey.FacilityNumber,
            state.CurrentSurvey.GUID,
            page.GUID];

        console.log("saving", path, section);

        sectionDispatcher.Save(path, section);
    }
};

module.exports = autosaver;


// WEBPACK FOOTER //
// ./src/autosaver.js